module.exports = __webpack_public_path__ + "img/wallet-desc-active.f9ac318b.png";